module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "mobile-menu",
    class: {
      open: _vm.mobile_menu
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/home'
      }
    }
  }, [_vm._v("Kezdőlap")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/palyazatok'
      }
    }
  }, [_vm._v("Pályázatok")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo-block"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/img/logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-block"
  }, [_c('ul', {
    staticClass: "mainmenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/home'
      }
    }
  }, [_vm._v("Kezdőlap")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/palyazatok'
      }
    }
  }, [_vm._v("Pályázatok")])], 1)]), _vm._v(" "), (this.$root.user == '') ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.$root.shibbolethLoginOpen || _vm.$root.tmpLoginOpen,
      "type": "button"
    },
    on: {
      "click": this.$root.openLoginPopup
    }
  }, [_vm._v("Belépés")]) : _vm._e(), _vm._v(" "), (this.$root.user != '') ? _c('div', {
    staticClass: "head-login-status"
  }, [_c('div', {
    staticClass: "photo",
    style: (_vm.photoStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "name-and-type"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(this.$root.user.name) + "\n          ")])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "mobile-toggle",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.openMobileMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dark-line"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("KTR")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n          Kiválósági és Támogatási Rendszer\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu",
    attrs: {
      "onclick": "openProfilMenu();",
      "href": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-123a2d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tpl_header.vue
// module id = 327
// module chunks = 0